<template>
  <div>
    <div class="vx-row">
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/contract-period" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.ViewContract") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
      <vx-card>
        <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click.stop="handleEditContract"
                      size="small"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deleteContractPeriodPopup = true"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
        <div class="vx-row">
          <div class="w-full">
            <div class="block overflow-x-auto">
              <table class="table w-full table-bordered table-striped">
                <tr>
                  <td>
                    <b>{{ $t("setup.label.ContractPeriod") }}</b>
                  </td>
                  <td>{{ contract.subscriptionPeriod }}</td>
                </tr>
                <tr>
                  <td>
                    <b>{{ $t("setup.label.ContractType") }}</b>
                  </td>
                  <td>{{ contract.subscriptionType }}</td>
                </tr>
                <tr>
                  <td>
                    <b>{{ $t("setup.label.ContractUnit") }}</b>
                  </td>
                  <td>{{ contract.units }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    </div>
    <delete-popup
      :deletePopup="deleteContractPeriodPopup"
      :title="$t('Contract Period')"
      @deletePressed="deleteContractPeriod()"
      @cancelPressed="deleteContractPeriodPopup = false"
    >
    </delete-popup>
  </div>
</template>

<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      contractId: null,
      deleteContractPeriodPopup: false,
      delId: 0,
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      contract: (state) => state.contractPeriod.contractDetailsById,
    }),
  },
  methods: {
    async getContractDetails() {
      this.loading = true;
      try {
        this.$store.dispatch(
          "contractPeriod/fetchContractDetails",
          this.contractId
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    handleEditContract() {
      this.$router.push({
        name: "Edit Contract",
        params: { id: this.contractId },
      });
    },
    async deleteContractPeriod() {
      try {
        this.deleteContractPeriodPopup = false;
        await this.$store.dispatch(
          "contractPeriod/deleteContractPeriodAction",
          this.contractId
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Contract period Deleted Successfully!",
          type: "success",
        });
        this.$router.push(`/setup/contract-period`);
      } catch (error) {
        this.$swal({
          title: "Error",
          icon: "error",
          text: error.message,
          type: "error",
        });
      }
    },
  },
  mounted() {
    this.contractId = this.$route.params.id;
    this.getContractDetails();
  },
};
</script>

<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
